import React, { useState, useCallback, useEffect } from 'react';
import { Maximize2, Minimize2 } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface FullscreenButtonProps {
  targetRef: React.RefObject<HTMLDivElement | null>;
}

export default function FullscreenButton({ targetRef }: FullscreenButtonProps) {
  const [isFullscreen, setIsFullscreen] = useState(false);

  useEffect(() => {
    const onChange = () => setIsFullscreen(!!document.fullscreenElement);
    document.addEventListener('fullscreenchange', onChange);
    return () => document.removeEventListener('fullscreenchange', onChange);
  }, []);

  const toggle = useCallback(() => {
    if (document.fullscreenElement) {
      document.exitFullscreen();
    } else if (targetRef?.current) {
      targetRef.current.requestFullscreen();
    }
  }, [targetRef]);

  return (
    <Button
      variant="outline"
      size="icon"
      onClick={toggle}
      title={isFullscreen ? 'Exit fullscreen' : 'Fullscreen'}
      className="absolute top-4 left-4 z-[110] size-8 bg-background/95 backdrop-blur-sm border-ctu-border text-ctu-text-muted hover:text-ctu-text"
    >
      {isFullscreen ? <Minimize2 className="size-4" /> : <Maximize2 className="size-4" />}
    </Button>
  );
}
